<template>
  <a-upload
    v-model:file-list="files"
    name="file"
    list-type="picture-card"
    :action="action"
    :before-upload="beforeUpload"
    :headers="headers"
    @change="handleChange"
    @preview="handlePreview"
  >
    <div v-if="files.length < 1">
      <loading-outlined v-if="loading"></loading-outlined>
      <plus-outlined v-else></plus-outlined>
      <div class="portal-ant-upload-text">Upload</div>
    </div>
  </a-upload>
  <a-modal :open="previewVisible" :footer="null" @cancel="handleCancel">
    <img alt="example" style="width: 100%" :src="previewImage" />
  </a-modal>
</template>
<script>
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { reactive, ref, toRefs } from 'vue'
import { message } from 'ant-design-vue'
export default {
  components: {
    LoadingOutlined,
    PlusOutlined
  },
  props: {
    fileList: Array
  },
  setup(props, context) {
    const loading = ref(false)
    const state = reactive({
      files: props.fileList || [],
      previewVisible: false,
      previewImage: '',
      headers: {
        Authorization: localStorage.getItem('token')
      },
      action: process.env.VUE_APP_upload + '/upload/oss'
    })
    const { emit } = context
    const getBase64 = file => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    }
    const handlePreview = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      state.previewImage = file.url || file.preview
      state.previewVisible = true
    }
    const beforeUpload = file => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        message.error('You can only upload JPG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!')
      }
      return isJpgOrPng && isLt2M
    }
    const handleChange = info => {
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        emit('change', info)
      }
    }
    const handleCancel = () => {
      state.previewVisible = false
    }
    return {
      ...toRefs(state),
      loading,
      handleChange,
      handlePreview,
      handleCancel,
      beforeUpload
    }
  }
}
</script>
<style lang="scss">
.portal-ant-upload-list-picture .portal-ant-upload-list-item,
.portal-ant-upload-list-picture-card .portal-ant-upload-list-item {
  padding: 0;
}
</style>
